import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "react-bootstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";

import Loader from "../Common/Loader/Loader";

import { closeHeaderModal } from "../../actions/siteadmin/modalActions";
import { userLogout } from "../../actions/user/userLogout";

import messages from "../../locale/messages";
import axios from "axios";
import bt from '../../components/commonStyle.css';


const Logout = () => {

    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const loading = useSelector(state => state?.loader?.userLogoutLoading)

    const handleClick = async (event) => {
        event.preventDefault();
        dispatch(closeHeaderModal('userLogout'))
        axios.post('/userLogout', {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
        await dispatch(userLogout());
    }
    return (
        <>
            <p className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor, bt.textAlignStart)}><FormattedMessage {...messages.logoutLabel} /></p>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={() => dispatch(closeHeaderModal('userLogout'))} className={bt.btnSecondary}><FormattedMessage {...messages.cancelButton} /></Button>
                <Loader
                    handleClick={(event) => handleClick(event)}
                    type='button'
                    buttonType='submit'
                    show={loading}
                    className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    label={formatMessage(messages.confirm)}
                />
            </div>

        </>
    )
}

export default withStyles(bt)(Logout);
